import React from 'react';


const Svgtrophy = (props) => {
  
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={364}
    height={364}
    fill='none'
    
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={8}
      d="M182 212.333v45.5m0-45.5c-36.688 0-67.29-26.053-74.316-60.666M182 212.333c36.688 0 67.29-26.053 74.317-60.666M182 257.833c14.105 0 21.157 0 26.944 1.55a45.507 45.507 0 0 1 32.173 32.173c1.55 5.786 1.55 12.839 1.55 26.944H121.333c0-14.105 0-21.158 1.551-26.944a45.503 45.503 0 0 1 32.172-32.173c5.787-1.55 12.839-1.55 26.944-1.55Zm-74.316-106.166H102.375c-10.57 0-15.856 0-20.252-.875a45.499 45.499 0 0 1-35.749-35.749c-.874-4.395-.874-9.68-.874-20.251 0-3.524 0-5.286.291-6.75a15.167 15.167 0 0 1 11.917-11.917c1.465-.292 3.227-.292 6.75-.292h41.709m1.517 75.834a76.17 76.17 0 0 1-1.517-15.167V69.333c0-8.085 0-12.128 1.502-15.247a15.16 15.16 0 0 1 7.084-7.084C117.872 45.5 121.914 45.5 130 45.5h104c8.086 0 12.128 0 15.248 1.502a15.17 15.17 0 0 1 7.084 7.084c1.501 3.119 1.501 7.162 1.501 15.247V136.5a76.17 76.17 0 0 1-1.516 15.167m0 0h5.308c10.571 0 15.857 0 20.252-.875a45.501 45.501 0 0 0 35.749-35.749c.874-4.395.874-9.68.874-20.251 0-3.524 0-5.286-.291-6.75a15.167 15.167 0 0 0-11.917-11.917c-1.465-.292-3.227-.292-6.75-.292h-41.709"
    />
  </svg>
  );
};

export default Svgtrophy;
